import mime from 'mime-types';
import axios from '../config/axios';
import {actions as A} from '../constants/actions';
import {setRequestId} from '../utils/setRequestId';

export const uploadFile = ({fileTypeId, file}) => {
  return (dispatch) => {
    const formData = new FormData();
    formData.append('fileType', fileTypeId);
    formData.append('fileExtension', mime.extension(file.type));
    formData.append('content', file);

    dispatch({type: A.UPLOAD_FILE});
    setRequestId();

    return axios.post(`/regGeneral/uploadFile`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(() => {
        dispatch({
          type: A.UPLOAD_FILE_SUCCESS,
        });
      })
      .catch((err) => {
        return dispatch({
          type: A.UPLOAD_FILE_FAILURE,
          payload: {errorMessage: err.message}
        })
      });
  };
};
